import SendCoupon from '@/views/webpc/MemberManagement/SendCouponList/SendCoupon'

// 定义路由路径数列表
export default [{
  path: '/sendCoupon',
  icon: 'el-icon-user',
  name: '发劵管理',
  component: SendCoupon
}]



// WEBPACK FOOTER //
// ./src/views/webpc/MemberManagement/SendCouponList/routers/index.js